import { NgModule } from '@angular/core';

import { AppURL } from './app.url';
import { PackageComponent } from './pages/package/package.component';
import { UiComponent } from './shareds/ui/ui.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PkDetailComponent } from './pages/package/pk-detail/pk-detail.component';
import { RouterModule, Routes } from '@angular/router';
import { WebOriginsComponent } from './pages/web-origins/web-origins.component';
import { SettingPaymentComponent } from './pages/setting-payment/setting-payment.component';
import { SettingComponent } from './pages/setting/setting.component';
import { RestApiComponent } from './pages/rest-api/rest-api.component';
import { KeyComponent } from './pages/key/key.component';
import { SecretKeyComponent } from './pages/secret-key/secret-key.component';
import { SecretKeyDetailComponent } from './pages/secret-key/secret-key-detail/secret-key-detail.component';
import { SecretKeyOtpComponent } from './pages/secret-key/secret-key-otp/secret-key-otp.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard, UnAuthGuard } from './guards/auth.guard';


const routes: Routes = [
  { path: AppURL.login, component: LoginComponent, canActivate: [UnAuthGuard] },

  {
    path: AppURL.package, canActivate: [AuthGuard], children: [
      { path: '', component: PackageComponent },
      { path: ':systemid', component: PkDetailComponent },
    ]
  },



  {
    path: AppURL.profile, canActivate: [AuthGuard], children: [
      { path: '', component: ProfileComponent },
    ]
  },
  {
    path: AppURL.weborigins, canActivate: [AuthGuard], children: [
      { path: '', component: WebOriginsComponent },
    ]
  },
  {
    path: AppURL.setting_payment, canActivate: [AuthGuard], children: [
      { path: '', component: SettingPaymentComponent },
    ]
  },
  {
    path: AppURL.setting, canActivate: [AuthGuard], children: [
      { path: '', component: SettingComponent },
    ]
  },
  {
    path: AppURL.systemkey, canActivate: [AuthGuard], children: [
      { path: '', component: KeyComponent },
    ]
  },
  {
    path: AppURL.restapi, canActivate: [AuthGuard], children: [
      { path: '', component: RestApiComponent },
    ]
  },
  {
    path: AppURL.secretkey, canActivate: [AuthGuard], children: [
      { path: '', component: SecretKeyComponent },
      { path: ':systemid', component: SecretKeyDetailComponent },
      { path: 'otp/:systemid', component: SecretKeyOtpComponent },
    ]
  },

  {
    path: AppURL.ui, canActivate: [AuthGuard], children: [
      { path: '', component: UiComponent },
    ]
  },
  { path: '**', canActivate: [AuthGuard], loadComponent: () => import('./pages/notfound/notfound.component') }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
